<template>
  <div relative w-full min-h-lg>
    <ClientOnly>
      <MapZone v-if="props.field == 'zone.zone2023.displayName'" :location="location" v-bind="$attrs" />
      <MapFeature
        v-else-if="selectedMap"
        :location="location"
        :source="selectedMap.source"
        :lineLayer="selectedMap.lineLayer"
        :labelLayer="selectedMap.labelLayer"
        :labelField="selectedMap.labelField"
        :featureId="value?.replace(' County', '')"
        :bbox="bbox"
        :filter="filter"
        v-bind="$attrs"
      />
      <MapWrapper
        v-else-if="hasLocation"
        :options="{
          center: [location.longitude, location.latitude],
          zoom: 15,
          style: '/styles/elevation-color.json',
        }"
        :marker="true"
        v-bind="$attrs"
      />
      <div v-else w-full h-lg bg-stone-100 bg-opacity-50></div>
      <template #fallback>
        <div w-full h-lg flex justify-center items-center text-stone-400 text-xl>Loading map&hellip;</div>
      </template>
    </ClientOnly>
  </div>
</template>
<script setup>
const props = defineProps({
  location: {
    type: Object,
  },
  field: {
    type: String,
  },
  value: {
    type: String,
  },
  bbox: {
    type: Array,
  },
  filter: {
    type: Array,
  },
});
const maps = {
  postalCode: {
    labelField: "GEOID20",
    source: {
      type: "vector",
      url: "/maps/zip.json",
      promoteId: "GEOID20",
      id: "zip",
      maxzoom: 11,
    },
    lineLayer: "features",
    labelLayer: "feature_names",
  },
  adminDistrict: {
    labelField: "NAME",
    source: {
      type: "vector",
      url: "/maps/state.json",
      promoteId: "NAME",
      id: "state",
      maxzoom: 10,
    },
    lineLayer: "features",
    labelLayer: "feature_names",
  },
  adminDistrict2: {
    labelField: "NAME",
    source: {
      type: "vector",
      url: "/maps/county.json",
      promoteId: "NAME",
      id: "county",
      maxzoom: 10,
    },
    lineLayer: "features",
    labelLayer: "feature_names",
  },
  "countySubdivision.fullName": {
    labelField: "NAME",
    source: {
      type: "vector",
      url: "pmtiles://https://tiles.whatismyelevation.com/2024-county-sub-place.pmtiles",
      promoteId: "NAME",
      id: "cousub_features",
      maxzoom: 10,
    },
    lineLayer: "cousub_features",
    labelLayer: "cousub_names",
  },
};
const selectedMap = computed(() => maps[props.field]);

const hasLocation = computed(() => {
  return isNumber(props.location?.latitude) && isNumber(props.location?.longitude);
});
</script>
